import TableRenderer from '../TableRenderer';
/* eslint-disable react/prop-types */ // TODO: add props

export const Table = ({ blockData: { content, withHeadings } }) => (
  <TableRenderer content={content} withHeadings={withHeadings} instructional />
);
